"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./sass/index.scss");

var _react = _interopRequireDefault(require("react"));

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _kmapRedux = require("kmap-redux");

var _reducers = _interopRequireDefault(require("./reducers"));

var _api = _interopRequireDefault(require("./middleware/api"));

var _App = _interopRequireDefault(require("./App"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // eslint-disable-next-line


require('./lib/icons'); // @ts-ignore


var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
var store = (0, _redux.createStore)(_reducers.default, composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk.default, (0, _api.default)(), (0, _kmapRedux.createKMapMiddleware)())));

var EmbeddedApp = function EmbeddedApp(props) {
  return /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
    store: store
  }, /*#__PURE__*/_react.default.createElement(_App.default, props));
};

var _default = EmbeddedApp;
exports.default = _default;